import { DS } from "../../../../theme-default";
import React from 'react';
import Select from "react-select";
import {RaisedButton, TextField} from "material-ui";

export default class ArticleAddRow extends React.Component {

    render() {
        return (
            <tr>
                <td>{this.props.code}</td>
                <td>
                    <div>
                        <Select
                            ref="stateSelect"
                            autoFocus options={this.props.productOps}
                            simpleValue
                            clearable={true}
                            name="selected-state"
                            disabled={false}
                            value={this.props.newProductId}
                            onChange={this.props.onProductChanged}
                            searchable={true}/>

                        <div>
                            {this.props.error.product
                            && <div style={{fontSize: '12px', color: DS.error, marginTop: '5px'}}>{this.props.error.product}</div>}
                        </div>
                    </div>
                </td>

                <td>
                    <TextField
                        style={{width: 200}}
                        hintText="Detalii"
                        type={"text"}
                        value={this.props.details}
                        rowsMax={2}
                        onChange={this.props.onDetailChanged}
                    />
                </td>
                <td>
                    <div className="field-line">
                        {
                            this.props.pricePredefined
                                ?
                                <TextField
                                    style={{width: 100}}
                                    disabled={true}
                                    value={this.props.price}
                                    hintText={this.props.price}
                                />
                                : <TextField
                                    style={{width: 100}}
                                    hintText="Pret"
                                    type={"number"}
                                    errorText={this.props.error.price}
                                    value={this.props.price}
                                    onChange={this.props.onPriceChanged}
                                />
                        }

                    </div>
                </td>

                <td>
                    <TextField
                        style={{width: 50}}
                        hintText="TVA"
                        type={"number"}
                        errorText={this.props.error.vat}
                        value={this.props.vat}
                        onChange={this.props.onVatChanged}
                    />
                </td>

                <td>
                    <TextField
                        style={{width: 100}}
                        hintText="Cantitatea"
                        type={"number"}
                        errorText={this.props.error.quantity}
                        value={this.props.quantity}
                        onChange={this.props.onQuantityChanged}
                    />
                </td>

                <td>
                    <RaisedButton
                        primary
                        label={"Salveaza"}
                        onClick={this.props.onAddArticleClicked}/>
                </td>
            </tr>
        )
    }
};